module.exports = __webpack_public_path__ + "img/icon_reds_bottom.abc12de7.png";